export default __webpack_public_path__ + "assets/icons/icon-search-grey.b00dc3418b23b4f8dbd2073625e045c5.svg";